module.exports = __webpack_public_path__ + "static/stdout-error-mode-586a5bdbe7d2d9debb9efe3ccb93e783.jpg";